<template>
  <div>
    <header-applis titre="Personnaliser l'offre à votre profil" sous-titre="Apprendre et se former tout au long de la vie" index-progression-courante="3"
                   index-progression-secondaire="9"/>
    <choix-competence-repeater :competences="competences" :callback="sauvegarder"/>
    <skip-competences ecrant-suivant="construireparcours"/>
    <footer-applis ecran-precedent="travaillerequipe" ecran-suivant="activitesquotidiennes" label-suivant="Je ne souhaite pas répondre aux questions"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';
import ChoixCompetenceRepeater from '../../components/ChoixCompetenceRepeater';
import SkipCompetences from '../../components/SkipCompetences';

export default {
  name: 'apprendreseformer',
  components: {
    SkipCompetences,
    ChoixCompetenceRepeater,
    HeaderApplis,
    FooterApplis
  },
  data() {
    return {
      competences: [{
        niveau: 1,
        valeur: 'J\'énonce mes manières habituelles d’apprendre'
      }, {
        niveau: 2,
        valeur: 'J\'envisage des possibles pour enrichir et varier mes façons d’apprendre'
      }, {
        niveau: 3,
        valeur: 'Je mets au point des stratégies nouvelles pour optimiser mon action'
      }, {
        niveau: 4,
        valeur: 'Je propose de nouvelles façons de réaliser certaines activités professionnelles'
      }]
    }
  },
  methods: {
    competencesTransversales() {
      return this.$store.getters.getCompetencesTansversales;
    },
    sauvegarder(competence) {
      let informations = {};
      Object.assign(informations, this.competencesTransversales());
      informations.apprendreseformer = competence;
      this.$store.commit('setCompetencesTransversales', informations);
      this.$router.push('construireparcours');
    }
  }
}
</script>
